<template lang="html">
    <div>
        <div class="d-flex">
            <!-- Channel -->
            <div class="w-100"><span class="bold">Sales Channel:</span> {{paymentChannel()}}</div>
            <!-- Is Request -->
            <div v-if="paymentValue(payment)" class="w-100"><span class="bold">Value:</span> {{paymentValue(payment)}}</div>
        </div>

        <div class="d-flex">
            <!-- Payment Method -->
            <div class="w-100 d-flex align-items-center">
                <span class="bold">Payment Method:</span>
                <v-select
                    :disabled="readOnly || isReservationReadOnly && reservation.status != -5"
                    class="pay-in__dropdown mx-2 d-flex"
                    :options="getPaymentTypeListAll"
                    label="description"
                    v-model="selectedPaymentMethod"
                    placeholder="- Select Payment Method -"
                    @input="updatePaymentMethod">
                </v-select>
            </div>
            <!-- Type -->
            <div class="w-100"><span class="bold">Type:</span> {{type(payment)}}</div>
        </div>

        <div v-if="treasurerName(payment)" class="d-flex">
            <!-- Treasurer -->
            <div v-if="treasurerName(payment)" class="w-100"><span class="bold">Treasurer:</span> {{treasurerName(payment)}}</div>
            <!-- Created on -->
            <div v-if="createDate(payment)" class="w-100"><span class="bold">Created on:</span> {{createDate(payment)}}</div>
        </div>

        <div v-if="paymentNotes(payment)" class="d-flex">
            <div class="w-100"><span class="bold">Notes:</span> {{paymentNotes(payment)}}</div>
        </div>


    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    created: function () {
        //select correct payment method for dropdown
        this.selectedPaymentMethod = this.getPaymentTypeListAll.find(pm => pm.id == this.payment.type)
    },
    mixins: [
        reservationsMixin,
    ],
    props: {
        payment: {
            type: Object,
            default: null,
            required: true
        },
        reservation:{
            type: Object
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function () {
        return {
            selectedPaymentMethod: null
        }
    },
    computed:{
        ...mapGetters([
            'getPaymentTypeListAll',
            'account',
        ]),
    },
    methods:{
        ...mapActions([
        ]),
        updatePaymentMethod: function (e) {
            // Activate update flag billing
            // done with watcher
            this.payment.type = e.id


        },
        paymentChannel: function () {
            if(this.payment.treasurerUserAccount){
                return this.payment.treasurerUserAccount.salesChannel.brandName
            } else if (this.treasurerAgent) {
                return this.treasurerAgent.brandName
            } else if(this.reservation.channelTypeDescription) {
                return this.reservation.channelTypeDescription
            }else {
                return '- Not found -'
            }
        },
        paymentValue: function (payemnt) {
            return this.formatPrice(payemnt.value) + '€'
        },
        type: function () {
            return this.payment.paymentDirection == 0? 'Pay In' : 'Pay Out'
        },
        treasurerName: function (payment) {
            let userName = null
            if(payment.treasurerUserAccount && payment.treasurerUserAccount.name){
                userName = payment.treasurerUserAccount.name
            } else if (payment.treasurerAgent && payment.treasurerAgent.brandName) {
                userName = payment.treasurerAgent.brandName
            } else if(payment.treasurerChannel && payment.treasurerChannel.brandName){
                userName = payment.treasurerChannel.brandName
            }
            return userName
        },
        createDate: function(payment) {
            return payment.createdOn? this.formatDateDots(payment.createdOn) + ' ' + this.formatTime(payment.createdOn) : false
        },
        paymentNotes: function (payment) {
            return payment.description? payment.description : false
        }
    },
    watch:{
        'payment.type':{
            handler: function (newVal, oldVal) {
                this.$emit('change')
                this.payment.treasurerUserAccount = this.account
                this.payment.treasurerChannel = this.account.salesChannel
                this.payment.treasurerSupplier = this.account.supplier
            }
        }
    },
    components:{
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss">
    .pay-in__dropdown {
        .dropdown-toggle {
            height: 1.5rem !important;

            .vs__actions {
                top: 3px !important;
            }

            .selected-tag, & input[type=search] {
                height: 1.4rem !important;
                margin: 0 !important;
                line-height: 1.4rem !important;
            }
        }

        .open-indicator {
            height: 14px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// payIn.vue?3ad5824c